import { FC, useState } from "react";
import { BaseProps } from "./text";
import GText from "./GText";
import useScrollTrigger from "../../functions/useScrollTrigger";
import { css } from "@emotion/react";
import { Easing, animate } from "motion";

interface Props {
  text?: string;
  duration?: number;
  delay?: number;
  easing?: Easing;
}

const GTextShowUp: FC<Props & BaseProps> = (props) => {
  const [isAnimationDone, setIsAnimationDone] = useState(false);
  const y = props.fontSize ? 2.5 * props.fontSize : 200;

  const styles = css`
    overflow-y: hidden;
    --y: ${y}px;

    & h1 {
      margin: 0;
      transform: translateY(var(--y));
    }
  `;

  const { ref } = useScrollTrigger(() => {
    if (ref.current && !isAnimationDone) {
      const h1 = ref.current.children[0];

      animate(
        h1,
        { y: [y, 0] },
        {
          duration: props.duration,
          easing: props.easing,
          delay: props.delay,
        }
      );

      setIsAnimationDone(true);
    }
  });

  return (
    <GText {...props}>
      <div ref={ref} css={styles} className="g-text-show-up">
        <h1>{props.text}</h1>
      </div>
    </GText>
  );
};

GTextShowUp.defaultProps = {
  text: "Grooody",
  color: "#000",
  fontSize: 30,
  duration: 0.3,
  delay: 1,
  easing: "ease-out",
};

export default GTextShowUp;

// We need to add the below in framer
/*
addPropertyControls(TextShowUp, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    color: {
        title: "Color",
        type: ControlType.Color,
        defaultValue: "#000",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
    duration: {
        title: "Duration",
        type: ControlType.Number,
        defaultValue: 0.3
    },
    delay: {
        title: "Delay",
        type: ControlType.Number,
        defaultValue: 1
    },
    ease: {
        title: "Ease",
        type: ControlType.Enum,
        defaultValue: "ease-out",
        displaySegmentedControl: true,
        segmentedControlDirection: "vertical",
        options: ["linear", "ease", "ease-in", "ease-out", "ease-in-out"],
    },
})

*/
